"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetType = exports.MerchantCustomIdType = exports.TransactionType = exports.TransactionStatus = exports.VirtualWalletProgram = exports.TransactionFeeType = void 0;
var TransactionFeeType;
(function (TransactionFeeType) {
    TransactionFeeType["ATM"] = "ATM";
    TransactionFeeType["DOMESTIC"] = "DOMESTIC";
    TransactionFeeType["NON_DOMESTIC"] = "NON_DOMESTIC";
    TransactionFeeType["FX"] = "FX";
    TransactionFeeType["UNKNOWN"] = "UNKNOWN";
})(TransactionFeeType = exports.TransactionFeeType || (exports.TransactionFeeType = {}));
var VirtualWalletProgram;
(function (VirtualWalletProgram) {
    VirtualWalletProgram["APPLE_PAY"] = "APPLE_PAY";
})(VirtualWalletProgram = exports.VirtualWalletProgram || (exports.VirtualWalletProgram = {}));
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["APPROVED"] = "APPROVED";
    TransactionStatus["CLEARED"] = "CLEARED";
    TransactionStatus["DECLINED"] = "DECLINED";
    TransactionStatus["REFUNDED"] = "REFUNDED";
    TransactionStatus["SETTLED"] = "SETTLED";
    TransactionStatus["REFUND"] = "REFUND";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
/**
 * Do not add any more types here that are not directly related to
 * a card transaction. If you want to add a new expense "extension" type
 * add it to the `family` column on the expense table.
 *
 * If your new type has a status lifecycle (pending, authorized, settled, etc)
 * it should be mapped to correspond to an existing transactionType. i.e. PRESENTMENT
 */
var TransactionType;
(function (TransactionType) {
    TransactionType["AUTHORIZATION"] = "AUTHORIZATION";
    TransactionType["AUTHORIZATION_INCREASE"] = "AUTHORIZATION_INCREASE";
    TransactionType["AUTHORIZATION_REVERSAL"] = "AUTHORIZATION_REVERSAL";
    TransactionType["BALANCE_ADJUSTMENT"] = "BALANCE_ADJUSTMENT";
    TransactionType["CHARGE_BACK"] = "CHARGE_BACK";
    TransactionType["INTERNAL_BALANCE_ADJUSTMENT"] = "INTERNAL_BALANCE_ADJUSTMENT";
    TransactionType["LOAD"] = "LOAD";
    TransactionType["SWEEP"] = "SWEEP";
    TransactionType["PRESENTMENT"] = "PRESENTMENT";
    TransactionType["SECOND_PRESENTMENT"] = "SECOND_PRESENTMENT";
    TransactionType["CHARGE_BACK_REVERSAL"] = "CHARGE_BACK_REVERSAL";
    TransactionType["UNLOAD"] = "UNLOAD";
    TransactionType["REFUND"] = "REFUND";
    TransactionType["MANUAL_EXPENSE"] = "MANUAL_EXPENSE";
    TransactionType["MANUAL_TRANSFER"] = "MANUAL_TRANSFER";
    TransactionType["BILL_INVOICE"] = "BILL_INVOICE";
    TransactionType["FAILED"] = "FAILED";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var MerchantCustomIdType;
(function (MerchantCustomIdType) {
    MerchantCustomIdType["CUSTOMER_ORDER"] = "CUSORD";
    MerchantCustomIdType["CUSTOMER_PURCHASE_ORDER"] = "CUSTPO";
    MerchantCustomIdType["FOLIO_NUMBER"] = "FOLNUM";
    MerchantCustomIdType["INVOICE_ACCOUNT_NUMBER"] = "INVACT";
    MerchantCustomIdType["OTHER"] = "OTHER1";
    MerchantCustomIdType["PAYMENT_REFERENCE_NUMBER"] = "PMTREF";
    MerchantCustomIdType["PURCHASE_IDENTIFIER"] = "PRCHID";
    MerchantCustomIdType["RECORD_LOCATOR"] = "RECLOC";
    MerchantCustomIdType["RESERVATION_NUMBER"] = "RESNUM";
    MerchantCustomIdType["RENTAL_AGREEMENT"] = "RNTAGR";
    MerchantCustomIdType["SUPPLIER_INVOICE"] = "SUPINV";
    MerchantCustomIdType["SUPPLIER_ORDER"] = "SUPORD";
    MerchantCustomIdType["TICKET_NUMBER"] = "TKTNUM";
    MerchantCustomIdType["TRANSACTION_ID"] = "TRANID";
    MerchantCustomIdType["TRACKING_NUMBER"] = "TRKNUM";
    MerchantCustomIdType["UNKNOWN"] = "UNKNOWN";
})(MerchantCustomIdType = exports.MerchantCustomIdType || (exports.MerchantCustomIdType = {}));
var TargetType;
(function (TargetType) {
    TargetType["CARD"] = "CARD";
    TargetType["WALLET"] = "WALLET";
    TargetType["EMPLOYEE"] = "EMPLOYEE";
    TargetType["COMPANY"] = "COMPANY";
})(TargetType = exports.TargetType || (exports.TargetType = {}));
//# sourceMappingURL=transaction.js.map